import { useQuasar } from "quasar";
import { putResendVerificationCode } from "src/api/user";
import PConfirmDialog from "src/components/PConfirmDialog.vue";
import PDialogForm from "src/components/PDialogForm.vue";

export function useContactVerification({ user, is_director = false }) {
  const $q = useQuasar();

  const { verifyUserVerificationCode } = useUserStore();

  const resendVerificationCodeLoader = ref(false);
  const verifyVerificationCodeLoader = ref(false);

  const resendVerificationCode = async ({
    userObj,
    update_director_phone = false,
  }) => {
    try {
      resendVerificationCodeLoader.value = true;

      let payloadBody = {};

      if (is_director) {
        payloadBody = {
          payload: {
            directors: [
              {
                _id: userObj.director?._id,
                phone: userObj.director?.phone,
              },
            ],
            user_id: unref(user)._id,
          },
          is_director: true,
          update_director_phone,
        };
      } else {
        payloadBody = {
          payload: {
            phone: userObj.phone,
            user_id: unref(user)?._id,
          },
        };
      }

      await putResendVerificationCode(payloadBody);

      resendVerificationCodeLoader.value = false;
    } catch (error) {
      console.error(error);

      resendVerificationCodeLoader.value = false;
    }
  };

  const confirmationHandler = (director) => {
    try {
      const confirmationDialog = $q.dialog({
        component: PConfirmDialog,
        componentProps: {
          labelClass: "text-center q-ma-sm rounded-borders",
          label: `We noticed that the phone number for ${director.name} has been changed. Please confirm if you'd like to update and proceed with the new number: ${director.phone}`,
          cancellable: true,
          cancelLabel: "Cancel",
          submitLabel: "Update & Send code",
          onConfirm: () => {
            resendVerificationCode({
              userObj: { director },
              update_director_phone: true,
            });

            confirmationDialog?.hide();
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const resend = async (userObj) => {
    if (is_director) {
      const savedDirectors = unref(user)?.businessDetails?.directors;
      const matchingDirector = savedDirectors?.find(
        (d) => d._id == userObj.director?._id,
      );

      if (matchingDirector.phone != userObj.director?.phone) {
        confirmationHandler(userObj.director);

        return;
      }
    }

    resendVerificationCode({ userObj });
  };

  const verifyVerificationCode = async (
    dialog,
    verification_code,
    { userObj },
  ) => {
    try {
      verifyVerificationCodeLoader.value = true;

      let payload = {};

      if (is_director) {
        payload = {
          otp: verification_code,
          user_id: unref(user)._id,
          director_id: userObj.director?._id,
          phone: userObj.director?.phone,
          is_director: true,
        };
      } else {
        payload = {
          otp: verification_code,
          user_id: unref(user)._id,
          phone: userObj.phone,
        };
      }

      await verifyUserVerificationCode(payload);

      verifyVerificationCodeLoader.value = false;

      dialog?.hide();
    } catch (error) {
      console.error(error);

      verifyVerificationCodeLoader.value = false;
    }
  };

  const verifyVerificationCodeModal = ({ phone, director }) => {
    let phoneNumber;
    let userObj = {};

    if (is_director) {
      phoneNumber = director?.phone;

      userObj = { director };
    } else {
      phoneNumber = phone;

      userObj = { phone };
    }

    const dialog = $q.dialog({
      component: PDialogForm,
      componentProps: {
        title: "Verify Contact Number",
        text: `Enter 4-digit verification code sent to +91 ${phoneNumber}`,
        submitLabel: "Submit",
        loading: verifyVerificationCodeLoader,
        form: {
          input: {
            placeholder: "Enter 4-digit verification code",
            label: "Verification Code",
            required: true,
            maxlength: "4",
            type: "number",
            hideBottomSpace: true,
            validations: {
              length: 4,
              type: "number",
            },
          },
          inputCta: {
            label: "Resend code",
            flat: true,
            class: "q-pa-none",
            dense: true,
            loading: resendVerificationCodeLoader,
            onClick: () => resend(userObj),
          },
        },
        onConfirm: (verification_code) => {
          verifyVerificationCode(dialog, verification_code, { userObj });
        },
      },
    });
  };

  return {
    verifyVerificationCodeModal,
  };
}
